import { useEffect } from "react";
import { X } from "lucide-react";

const ModalLayout = ({
  children,
  cross = true,
  closeHandler,
  size = "default",
}) => {
  // Close on ESC key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        closeHandler?.();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    // Prevent background scroll
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "auto";
    };
  }, [closeHandler]);

  // Close on backdrop click
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeHandler?.();
    }
  };

  return (
    <div
      onClick={handleBackdropClick}
      className="fixed inset-0 top-0 min-h-screen bg-black/60 flex items-center justify-center p-4 z-50 animate-fadeIn"
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`bg-white rounded-2xl w-full ${
          size === "large" ? "min-w-full" : "max-w-md"
        } p-6 relative animate-scaleIn`}
      >
        {cross && (
          <button
            onClick={closeHandler}
            className="absolute top-4 right-4 text-textSubHeading hover:text-textHeading transition-colors z-20 p-1"
          >
            <X className="w-4 h-4" />
            <span className="sr-only">Close</span>
          </button>
        )}

        {children}
      </div>
    </div>
  );
};

export default ModalLayout;
